import { render } from "./VODTagsManage.vue?vue&type=template&id=7f4d8266&scoped=true"
import script from "./VODTagsManage.vue?vue&type=script&lang=js"
export * from "./VODTagsManage.vue?vue&type=script&lang=js"

import "./VODTagsManage.vue?vue&type=style&index=0&id=7f4d8266&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4d8266"]])

export default __exports__